import rcImg from '../realconnect-image-front-lowres.png';

function LogoPane() {
  const style = {
    float: 'left',
    minHeight: 'calc(100vh - 100px)',
    paddingBottom: '500px',
  };
  const spacerStyle = { height: '40px' };
  return (
    <div id="colA" style={style}>
      <h2 style={{ paddingLeft: '20px' }}>
        Poly RealConnect
        <br />
        for Office 365
        <br />
        and Microsoft Teams
      </h2>
      <div style={spacerStyle} />
      <img src={rcImg} alt="RealConnect" />
      <br />
      <p />
    </div>
  );
}

export default LogoPane;
